import { useLocation } from "react-router-dom";
import { useVouchersDistributionState } from "../store/use-vouchers-distribution-state";
import type { ConfigName } from "../types/config-name";

type OfferType = Extract<ConfigName, "free_packages" | "purchase_products" | "friends_and_family">;

export const useCurrentOfferType = (): OfferType | null => {
  const { pathname } = useLocation();
  const { voucherDistribution } = useVouchersDistributionState();

  if (!voucherDistribution) return null;

  for (const config of voucherDistribution.configs) {
    if (config.configName === "consultations") continue;
    // config.path is absolute like "/pp/slug/dla-bliskich"; strip basename by checking prefix
    const configSegment = config.path.replace(`/pp/${voucherDistribution.slug}`, "");
    if (configSegment && pathname.startsWith(configSegment)) {
      return config.configName as OfferType;
    }
  }

  return null;
};
